import type { ChapterEnum, WorkOrderChangeStatusEnum, WorkOrderStatusEnum } from 'gql/graphql';
import { EditMtrDialog } from 'pages/Project/UerProject/PriceList/EditMtrDialog';
import { Button } from 'uikit';

import type React from 'react';
import { useCallback, useState } from 'react';

import { EditWorkOrderChangeMtrDialog } from '../WorkOrderChange/EditWorkOrderChangeMtrDialog';

interface ICreateEditMtrDialog {
    disabledBtn?: boolean;
    onCloseMatchDialog?: () => void;
    chapter?: ChapterEnum;
    workOrderStatus?: WorkOrderStatusEnum | WorkOrderChangeStatusEnum;
    isChange: boolean;
    mtrId?: number;
    workOrderChangePriceId?: number;
    refreshTableDataHandler?: () => void;
}

export const CreateEditMtrDialog: React.FC<ICreateEditMtrDialog> = (props) => {
    const {
        disabledBtn,
        onCloseMatchDialog,
        chapter,
        workOrderStatus,
        isChange,
        mtrId,
        workOrderChangePriceId,
        refreshTableDataHandler,
    } = props;

    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

    const handleOpenModal = useCallback(() => {
        setIsOpenModal(true);
    }, []);

    const handleChangeCloseModal = useCallback(() => {
        setIsOpenModal(false);
        onCloseMatchDialog?.();
    }, [onCloseMatchDialog]);

    return (
        <>
            <Button label="Заполнить данные по МТР" onClick={handleOpenModal} view="secondary" disabled={disabledBtn} />
            {isOpenModal && !isChange && (
                <EditMtrDialog
                    isOpenModal={isOpenModal}
                    setIsOpenModal={setIsOpenModal}
                    onCloseMatchDialog={onCloseMatchDialog}
                    chapter={chapter}
                    workOrderStatus={workOrderStatus as WorkOrderStatusEnum}
                />
            )}
            {isOpenModal && isChange && chapter && (
                <EditWorkOrderChangeMtrDialog
                    isModalOpened={isOpenModal}
                    closeModalHandler={handleChangeCloseModal}
                    mtrId={mtrId}
                    workOrderChangePriceId={workOrderChangePriceId}
                    refreshTableDataHandler={refreshTableDataHandler}
                    chapter={chapter}
                />
            )}
        </>
    );
};

CreateEditMtrDialog.displayName = 'CreateEditMtrDialog';
